import React, { useContext } from 'react';
import { Table, Tbody, Thead, Tr, Td, Th } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import EkovillaContext from '../contexts/EkovillaContext';

import EkovillaMeter from './EkovillaMeter';

function EkovillaTotal() {

    const { ekovilla } = useContext(EkovillaContext);

    const woolCarbonFoot = 0.128;
    const woolCarbonHand = 1.34;
    const boardCarbonFoot = 0.5;
    const boardCarbonHand = 0.6;

    let woolTotalCubic = 0;
    let woolTotalWeight = 0;
    let boardTotalCubic = 0;
    let boardTotalWeight = 0;

    Object.values(ekovilla).forEach(value => {
        if (value.product === "Ekovilla puhallusvilla") {
            woolTotalCubic = woolTotalCubic + value.insulationCubic;
            woolTotalWeight = woolTotalWeight + value.insulationWeight;
        }

        if (value.product === "Ekovillalevy") {
            boardTotalCubic = boardTotalCubic + value.insulationCubic;
            boardTotalWeight = boardTotalWeight + value.insulationWeight;
        }
    })

    const countTotalCarbon = (weight, carbon) => {
        const total = weight * carbon;
        return total;
    }

    return (
        <Table className="table-auto w-full">
            <Thead>
                <Tr>
                    <Th className=""></Th>
                    <Th className="text-sm xl:text-base">m<sup>3</sup></Th>
                    <Th className="text-sm xl:text-base">Käyttö kg</Th>
                    <Th className="text-sm xl:text-base">Hiilijalanjälki kg CO<sub>2</sub>e</Th>
                    <Th className="text-sm xl:text-base">Hiilikädenjälki kg CO<sub>2</sub>e</Th>
                </Tr>
            </Thead>
            <Tbody>
                <Tr className="border-collapse border border-gray-600">
                    <Td className="text-left pl-1 text-sm xl:text-base">Puhalluseriste yhteensä</Td>
                    <Td className="text-center text-sm xl:text-base">{woolTotalCubic}</Td>
                    <Td className="text-center text-sm xl:text-base">{woolTotalWeight}</Td>
                    <Td className="text-center border-collapse border border-gray-600 text-sm xl:text-base">{countTotalCarbon(woolTotalWeight, woolCarbonFoot).toFixed(1)}</Td>
                    <Td className="text-center border-collapse border border-gray-600 text-sm xl:text-base">{countTotalCarbon(woolTotalWeight, woolCarbonHand).toFixed(1)}</Td>
                </Tr>
                <Tr className="border-collapse border border-gray-600">
                    <Td className="text-left pl-1 text-sm xl:text-base">Levyeriste yhteensä</Td>
                    <Td className="text-center text-sm xl:text-base">{boardTotalCubic}</Td>
                    <Td className="text-center text-sm xl:text-base">{boardTotalWeight}</Td>
                    <Td className="text-center border-collapse border border-gray-600 text-sm xl:text-base">{countTotalCarbon(boardTotalWeight, boardCarbonFoot).toFixed(1)}</Td>
                    <Td className="text-center border-collapse border border-gray-600 text-sm xl:text-base">{countTotalCarbon(boardTotalWeight, boardCarbonHand).toFixed(1)}</Td>
                </Tr>
                <Tr>
                    <Td className="hidden sm:table-cell"></Td>
                    <Td className="hidden sm:table-cell"></Td>
                    <Td className="hidden sm:table-cell"></Td>
                    <Td className="meter border-collapse border border-gray-600 text-sm xl:text-base">
                        <EkovillaMeter
                            maxValue={(woolTotalWeight + boardTotalWeight)}
                            value={countTotalCarbon(woolTotalWeight, woolCarbonFoot) + countTotalCarbon(boardTotalWeight, boardCarbonFoot)}
                            startColor="#FFFF00"
                            endColor="#FF0000"
                            showValue={true}
                        />
                    </Td>
                    <Td className="meter border-collapse border border-gray-600 text-sm xl:text-base">
                        <EkovillaMeter
                            maxValue={(woolTotalWeight + boardTotalWeight) * 2}
                            value={countTotalCarbon(woolTotalWeight, woolCarbonHand) + countTotalCarbon(boardTotalWeight, boardCarbonHand)}
                            startColor="#FFFF00"
                            endColor="#004d00"
                            showValue={true}
                        />
                    </Td>
                </Tr>
            </Tbody>
        </Table>
    )
}

export default EkovillaTotal;